export enum RegiaoEnum {

  SUDENE = 1,
  SUDAM = 2,
  CENTRO_OESTE = 3,
  DEMAIS_REGIOES = 4
  
}
